import { render, staticRenderFns } from "./teachingMode.vue?vue&type=template&id=dfedc47a&scoped=true"
import script from "./teachingMode.vue?vue&type=script&lang=js"
export * from "./teachingMode.vue?vue&type=script&lang=js"
import style0 from "./teachingMode.vue?vue&type=style&index=0&id=dfedc47a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfedc47a",
  null
  
)

export default component.exports